<template>
  <div>
    <div class="app-title">
      <em-view-title :crudState="$_emCommonListMixin_pathType"></em-view-title>
    </div>
    <section class="app-content">
      <div id="accordionFilter" class="content">
        <div class="card">
          <div id="collapseOne" class="collapse show" aria-labelledby="headingOne"
               data-parent="#accordionFilter">
            <div class="card-body">
              <form>
                <em-filter :entity="modelName" ref="emListFilter"
                           @showEntityModalSelect="$_emCommonModalMixin_showModalSelectorByFilter"></em-filter>
              </form>
            </div>
          </div>
        </div>
      </div>
      <div id="sithMesAndonTypePositionResultTable" class="content">
        <div class="card my-1">
          <div id="collapseTwo" class="collapse show" aria-labelledby="headingTwo"
               data-parent="#accordionResult">
            <div class="card-body">
              <em-table :entity="modelName" withCustomRowActions
                        ref="emTable" exportDisabled :inlineActionsDisabled="prop_inline!=='1'"
                        @showModalSelectorByNewRow="$_emCommonModalMixin_showModalSelectorByNewRow"
                        @showModalSelectorByEditRow="$_emCommonModalMixin_showModalSelectorByEditRow">
                <template #customRowActions="{row}">
                  <b-button-group>
                    <em-button type="gotoGrandParent" customLabel="岗位" show-name
                               v-bind:class="'btn btn-outline-primary btn-sm'"
                               @click="gotoGrandParentLevel(row)">
                    </em-button>
                  </b-button-group>
                </template>
              </em-table>
            </div>
          </div>
        </div>
      </div>
    </section>
    <em-modal-entity-selector ref="emModalEntitySelector"></em-modal-entity-selector>
  </div>
</template>
<script>
// Author Eric
// Date 2020-09-18 09:17:42

import emCommonListMixin from "@/mixin/em/common/list";
import emCommonGotoMixin from "@/mixin/em/common/goto";

export default {
  name: "sithMesAndonTypePositionListView",
  mixins: [emCommonListMixin, emCommonGotoMixin],
  props: {
    //是否启用行编辑
    prop_inline: {
      type: String,
      default: "0"
    }
  },
  computed: {
    modelName() {
      return this.$_emRouterHelperMixin_entityName
    }
  },
  methods: {
    gotoGrandParentLevel(row) {
      this.$_emGotoMixin_gotoList("sithMesMstPosition", row.mstPositionId ? row.mstPositionId : "")
    }
  }
};
</script>